import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import ActivationWizard from '../src/javascript/components/activation_wizard/ActivationWizard.jsx';

import '../src/stylesheets/activation_wizard.scss';
import 'bootstrap/dist/js/bootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<ActivationWizard />);
